import { render, staticRenderFns } from "./EmployeeFamilyInformation.vue?vue&type=template&id=87947ec0&"
import script from "./EmployeeFamilyInformation.vue?vue&type=script&lang=js&"
export * from "./EmployeeFamilyInformation.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeFamilyInformation.vue?vue&type=style&index=0&id=87947ec0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports